export default __webpack_public_path__ + "static/media/profileDotBitIcon.a7c4db49.svg";